import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'vault-layout-simple-form',
  templateUrl: './layout-simple-form.component.html',
  styleUrls: ['./layout-simple-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LayoutSimpleFormComponent {}
